import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/console/machines")({
  component: () => <Outlet />,
});
